<div class="admin-container">
  <aside class="admin-sidebar">
    <h2>{{ 'admin.layout.title' | localize }}</h2>
    <nav>
      <a routerLink="/admin/forms" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        {{ 'admin.layout.forms' | localize }}
      </a>
      <a routerLink="/admin/forms/new" routerLinkActive="active">
        {{ 'admin.layout.createForm' | localize }}
      </a>
      <a routerLink="/admin/forwarding" routerLinkActive="active">
        {{ 'admin.layout.forwarding' | localize }}
      </a>
    </nav>
  </aside>
  <main class="admin-content">
    <router-outlet></router-outlet>
  </main>
</div>
